export class CancelCaseCommand{
    centerId:string;
    visitKey:string;

    constructor (centerId:string, visitKey:string){
        this.centerId = centerId;
        this.visitKey = visitKey;
    }
}